// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__scQna","footer":"ModalUpdate_footer__2jVSK"};